export default __webpack_public_path__ + "static/media/account-view.46b299e2.jpg";